// Ploufe — zet [data-past-hero] op de header zodra de eerste sectie (de hero
// op de homepage) tot op 220px na buiten beeld is gescrold (zie rootMargin). Losstaand van Horizon's
// eigen sticky-detectie (die op de hoogte van de header zelf let, niet op de
// hero), zodat de overgang precies "voorbij de hero" gebeurt.
(() => {
  const header = document.getElementById('header-component');
  if (!header || !header.hasAttribute('transparent')) return;

  const hero = document.querySelector('.content-for-layout > .shopify-section:first-child');
  if (!hero) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      header.toggleAttribute('data-past-hero', !entry.isIntersecting);
    },
    // Al ondoorzichtig zodra de onderkant van de hero binnen de 220px komt
    // van het donkere verloop achter de transparante header (lan-header
    // ::before), zodat dat verloop nooit over de sectie onder de hero valt.
    { threshold: 0, rootMargin: '-220px 0px 0px 0px' }
  );

  observer.observe(hero);
})();
